import GetSuppliersLookupRequestModel from '../../../generated/types/model/request/GetSuppliersLookupRequestModel';

export default class GetSuppliersLookupRequestViewModel extends GetSuppliersLookupRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
